export default __webpack_public_path__ + "static/media/tune-24px.1c5e80e1.svg";